import QuickReconcile from './QuickReconcile';
import { ActionRef } from 'further-types/lp/action';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from 'further-ui/utils';
import CreateTransfer from './CreateTransfer';
import { useFormContext } from 'react-hook-form';
import { FormValues } from '..';
import TabsPanel from 'further-ui/components/TabsPanel';
import { Card, CardContent } from 'further-ui/components/Card';
import { styled } from '@mui/material';
import { BankOperationActionsMode } from './types';

export { BankOperationActionsMode } from './types';

const TabCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    minHeight: 170,
  },
}));

type Props = {
  bankAccountOperationId: string;
  isOutgoingTransaction: boolean;
  onFindAndMatch: (
    bankAccountOperationId: string,
    transactionId?: string,
  ) => void;
  matchingReconcilableTransactions: Array<{
    id: string;
    unreconciledAmountTcy: number;
    counterpartyLabel: string;
    actionRef: ActionRef;
    currencyCode: CurrencyCode;
    ledgerDate: CalendarDay;
  }>;
};

const BankOperationActions: React.FC<Props> = ({
  isOutgoingTransaction,
  bankAccountOperationId,
  onFindAndMatch,
  matchingReconcilableTransactions,
}) => {
  const { setValue } = useFormContext<FormValues>();

  const handleShowFindAndMatch = (transactionId?: string) => {
    onFindAndMatch(bankAccountOperationId, transactionId);
  };

  const tabs = [
    {
      key: BankOperationActionsMode.QuickReconcile,
      label: 'Match',
      content: (
        <Card variant="outlined">
          <TabCardContent size="md">
            <QuickReconcile
              matchingReconcilableTransactions={
                matchingReconcilableTransactions
              }
              onFindAndMatch={handleShowFindAndMatch}
            />
          </TabCardContent>
        </Card>
      ),
    },
    ...(isOutgoingTransaction
      ? [
          {
            key: BankOperationActionsMode.CreateTransfer,
            label: 'Create transfer',
            content: (
              <Card variant="outlined">
                <TabCardContent size="md">
                  <CreateTransfer />
                </TabCardContent>
              </Card>
            ),
          },
        ]
      : []),
  ];

  return (
    <TabsPanel
      tabs={tabs}
      tabMargin="sm"
      defaultTab={BankOperationActionsMode.QuickReconcile}
      onTabChange={(tab) => setValue('mode', tab)}
      fullHeight
      contentSpacing="none"
      disableFullWidth
      hideTabsDivider
    />
  );
};

export default BankOperationActions;
